import { Box, SpeedDial, SpeedDialIcon, Typography, containerClasses } from '@mui/material';
import React, { useState } from 'react'
import TableClients from '../../../../components/administrative/clients/clientsTable/tableClients';
import Client from '../../../../components/administrative/clients/client/client';

const ClientsPage = () => {
  const [open, setOpen] = useState();
  const [values, setValues] = useState({});
  const [editing, setEditing] = useState(false);
  const [changed, setChanged ] = useState(false); 

  const handleChanged = () => {
    setChanged(!changed);
  }

  const handleNewClient = () => {
    setValues({
          hour_technical: 'N',
          show_alert: 'N',
        });
    setEditing(false);
    setOpen(true);
  }

  return (
    <div style={{padding: 20, overflow: 'scroll', width: '100%', height: '100%'}}>
      <Box>
        <Client 
          open={open}
          setOpen={setOpen} 
          values={values}
          setValues={setValues}
          editing={editing}
          setEditing={setEditing}
          handleChanged={handleChanged}
        />
      </Box>
      <TableClients
        open={open}
        setOpen={setOpen} 
        values={values}
        setValues={setValues}
        editing={editing}
        setEditing={setEditing}
        changed={changed}
        handleChanged={handleChanged}
      />

      <SpeedDial
              ariaLabel="Novo Cliente"
              sx={{ position: 'fixed', top: 70, right: 16, }}
              icon={<SpeedDialIcon  />}
              onClick={handleNewClient}
              >
        </SpeedDial>
    </div>
  )
}

export default ClientsPage;